export default __webpack_public_path__ + "static/media/sonnant_logo_reverse_with_by_soundstack_subtle.9eb6aba6.svg";